export default "__VITE_ASSET__B6Y$UN1D__"